import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/solutions/$pillarSlug")({
  head: () => buildRouteHead("/es/solutions/$pillarSlug", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/soluciones", replace: true });
  },
});
